module.exports = __webpack_public_path__ + "img/Bodice-Front-B1-Db-Ee-Gb.3241147f.png";